// Estilos de CTA estilo Spotify. En modo OSCURO el botón principal es BLANCO con texto
// negro; en modo CLARO pasa a tinta navy con texto blanco. Como estos `sx` se consumen
// con object-spread (`{ ...premiumButtonSx, mt: 3 }`) NO pueden ser funciones de `theme`,
// así que leen variables CSS mode-aware definidas en CssBaseline (`--otx-cta-*`). El
// dorado queda solo como acento puntual (links, íconos, item de menú activo, foco, badges).
// Reglas de taste-skill: 1 acento contenido, hover/active visibles, cubic-bezier.

export const GOLD = '#F9BD4E';
export const GOLD_DARK = '#F8B131';
export const INK = '#111418';

const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

const baseButtonSx = {
  py: 1.4,
  borderRadius: 2.5,
  fontWeight: 800,
  fontSize: '1rem',
  textTransform: 'none',
  letterSpacing: 0.2,
  transition: `transform 200ms ${EASE}, filter 200ms ${EASE}, background-color 200ms ${EASE}`,
  '&:active': { transform: 'scale(0.98)' },
  '&.Mui-focusVisible': { outline: '2px solid var(--otx-focus-ring)', outlineOffset: 2 },
  '&.Mui-disabled': {
    backgroundColor: 'var(--otx-btn-disabled-bg)',
    color: 'var(--otx-btn-disabled-text)',
    boxShadow: 'none'
  }
};

// CTA principal: mode-aware vía variables CSS (blanco/negro en oscuro, navy/blanco en claro).
export const premiumButtonSx = {
  ...baseButtonSx,
  color: 'var(--otx-cta-text)',
  backgroundColor: 'var(--otx-cta-bg)',
  '&:hover': {
    backgroundColor: 'var(--otx-cta-bg)',
    transform: 'scale(1.02)',
    filter: 'brightness(0.94)'
  }
};

// Botón de acento dorado, compacto (uso puntual, no para los CTA grandes). El dorado y su
// texto navy funcionan igual en ambos modos, así que se mantiene estático.
export const goldAccentButtonSx = {
  ...baseButtonSx,
  color: INK,
  backgroundColor: GOLD,
  '&:hover': { backgroundColor: GOLD_DARK, transform: 'scale(1.02)' }
};
